import {
  FETCH_RECORDS,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAIL,
  WAIT,
  WAIT_SUCCESS,
  WAIT_FAIL
} from "./types";
import {
  delRequest,
  getRequest,
  postRequest,
  putRequest
} from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";
import download from "downloadjs";
import { isExternalFinanceStoreSubscription } from "../../../financeTierAccess";

const FINANCE_HOME_PATH = "/warehousing/finance";

export const getTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.transactions)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  // Async JSON import only — never multipart / raw workbook.
  // Body must be { source, transactions: non-empty array }. Expect 202 + transactionImportTaskId.
  const source = data?.source;
  const transactions = data?.transactions;
  if (!Array.isArray(transactions) || transactions.length === 0) {
    notification.error({
      message: "No transactions to import",
      description: "Parse the invoice in the browser and POST a non-empty transactions array as JSON.",
    });
    return dispatch({ type: WAIT_FAIL });
  }

  const body = {
    ...(source ? { source } : {}),
    transactions,
  };

  postRequest(body, undefined, undefined, token, endpoints.whFinance.transactions)
    .then((response) => {
      dispatch({ type: WAIT_SUCCESS, payload: response.data });
      const transactionImportTaskId = response.data?.transactionImportTaskId;
      notification.success({ message: response.data?.message || 'Transaction import started.' });
      if (navigate && transactionImportTaskId) {
        navigate(`/warehousing/finance/transactions/import/progress/${transactionImportTaskId}`);
      }
      return response.data;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getTransactionImportTask = (taskId) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest(undefined, `/${taskId}`, token, endpoints.whFinance.transactionImport.root)
    .then((response) => response.data.task)
    .catch((err) => {
      throw err;
    });
};

export const editTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.whFinance.transactions)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteTransactions = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.whFinance.transactions)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getPayouts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.payouts)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addPayouts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.payouts)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message })
      dispatch({
        type: WAIT_SUCCESS,
        payload: data
      });
      navigate && navigate("/warehousing/finance/payouts");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const editPayouts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.whFinance.payouts)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deletePayouts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.whFinance.payouts)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getServiceFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addServiceFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/warehousing/finance/serviceFees");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editServiceFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteServiceFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getUnpaidOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getPayoutsDue = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.payoutsDue)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getCashCycles = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.cashcycle)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.fees)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: WAIT_SUCCESS
      });
      navigate && navigate("/warehousing/finance/payouts/due");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.vendors)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getVendorFinanceDetails = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.vendors)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data,
        store: "vendorFinance"
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.dashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data?.dashboard ?? data,
        store: "dashboard",
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const extractInvoice = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, endpoints.whFinance.invoices)
    .then((response) => {
      const { data } = response;
      download(data, response.headers["filename"], "application/pdf");
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getUploadUrl = (data) => (dispatch, useState) => {
  const token = useState().auth?.token;

  return getRequest(data, undefined, token, endpoints.whFinance.uploadUrl)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to get upload URL",
      });
      console.log(err);
      throw err;
    });
};

export const addTransactionProof = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.proof)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Proof uploaded successfully" })
      dispatch({
        type: WAIT_SUCCESS,
      });
      if (navigate) {
        navigate("/warehousing/finance");
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to upload proof",
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const deleteTransactionProof = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return delRequest(data, undefined, token, endpoints.whFinance.transactionProof)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Proof deleted successfully",})
      dispatch({
        type: WAIT_SUCCESS,
      });
      if (navigate) {
        navigate("/warehousing/finance");
      }
      return response;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to delete proof",
      });
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      throw err;
    });
};

export const deleteTransaction = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return delRequest(data, undefined, token, endpoints.whFinance.transactions)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Transaction deleted successfully",})
      dispatch({
        type: WAIT_SUCCESS,
      });
      if (navigate) {
        navigate("/warehousing/finance");
      }
      return response;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message || "Failed to delete transaction",
      });
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      throw err;
    });
};

export const getServiceFeeTiers = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.serviceFeeTiers)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addServiceFeeTier = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.serviceFeeTiers)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Tier created successfully",})
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate) {
        const user = useState().auth?.user;
        navigate(
          isExternalFinanceStoreSubscription(user)
            ? FINANCE_HOME_PATH
            : "/warehousing/finance/service-fee-tiers"
        );
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const editServiceFeeTier = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return putRequest(data, undefined, undefined, token, endpoints.whFinance.serviceFeeTiers)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Tier updated successfully", });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate) {
        const user = useState().auth?.user;
        navigate(
          isExternalFinanceStoreSubscription(user)
            ? FINANCE_HOME_PATH
            : "/warehousing/finance/service-fee-tiers"
        );
      }
      return data;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      throw err;
    });
};

export const deleteServiceFeeTier = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return delRequest(data, undefined, token, endpoints.whFinance.serviceFeeTiers)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Tier deleted successfully", });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate) {
        const user = useState().auth?.user;
        navigate(
          isExternalFinanceStoreSubscription(user)
            ? FINANCE_HOME_PATH
            : "/warehousing/finance/service-fee-tiers"
        );
      }
      return response;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({
        type: WAIT_FAIL
      });
      throw err;
    });
};

export const getBrandServiceFees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const updateBrandServiceFee = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.whFinance.serviceFees)
    .then((response) => {
      const { data } = response;
      notification.success({ message: data.message || "Service fee updated successfully",})
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate) {
        const user = useState().auth?.user;
        navigate(
          isExternalFinanceStoreSubscription(user)
            ? FINANCE_HOME_PATH
            : "/warehousing/finance/brand-service-fees"
        );
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getSubscriptionWaivers = (data) => (dispatch, useState) => {
  const token = useState().auth?.token;

  return getRequest(data, undefined, token, endpoints.whFinance.subscriptionWaivers)
    .then((response) => {
      const { data: responseData } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: responseData?.waivers ?? responseData,
        store: "subscriptionWaivers",
      });
      return responseData;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      throw err;
    });
};

export const checkSubscriptionWaiver = (data) => (dispatch, useState) => {
  const token = useState().auth?.token;

  return getRequest(data, "/check", token, endpoints.whFinance.subscriptionWaivers)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const createSubscriptionWaiver = (data) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return postRequest(data, undefined, undefined, token, endpoints.whFinance.subscriptionWaivers)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData.message || "Subscription waiver created",
      });
      dispatch({ type: WAIT_SUCCESS });
      return responseData;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const updateSubscriptionWaiver = ({ id, ...body }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return putRequest(body, undefined, `/${id}`, token, endpoints.whFinance.subscriptionWaivers)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData.message || "Subscription waiver updated",
      });
      dispatch({ type: WAIT_SUCCESS });
      return responseData;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};

export const revokeSubscriptionWaiver = (id) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  return delRequest(undefined, `/${id}`, token, endpoints.whFinance.subscriptionWaivers)
    .then((response) => {
      const { data: responseData } = response;
      notification.success({
        message: responseData.message || "Subscription waiver revoked",
      });
      dispatch({ type: WAIT_SUCCESS });
      return responseData;
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      dispatch({ type: WAIT_FAIL });
      throw err;
    });
};